export const validateUserInfo = (formInfo) => {
    if (
        formInfo.userName &&
        formInfo.userInitials &&
        formInfo.impStatus.SK &&
        formInfo.rushStatus.SK &&
        formInfo.carePlanSelected !== undefined
    ) {
        return true;
    }
    return false;
};
